import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../hooks/useNotifications';
import NotificationList from '../components/Notifications/NotificationList';
import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotificationsPage: React.FC = () => {
    const { pubkey } = useAuth();
    const { events, isLoading, loadMore, markAsRead } = useNotifications(pubkey);

    useEffect(() => {
        if (markAsRead) {
            markAsRead();
        }
    }, [markAsRead]);

    if (!pubkey) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[50vh] text-center p-6">
                <div className="w-16 h-16 bg-gray-100 dark:bg-surface-800 rounded-full flex items-center justify-center mb-6">
                    <Bell className="w-8 h-8 text-gray-400" />
                </div>
                <h2 className="text-2xl font-bold font-poppins text-gray-900 dark:text-white mb-4">
                    Giriş Yapmalısınız
                </h2>
                <p className="text-gray-600 dark:text-gray-400 font-poppins mb-8 max-w-md">
                    Bildirimlerinizi görmek için hesabınıza giriş yapmanız gerekmektedir.
                </p>
                <Link
                    to="/login"
                    className="px-6 py-3 bg-mavi-500 hover:bg-mavi-600 text-white rounded-xl font-poppins font-medium transition-colors"
                >
                    Giriş Yap
                </Link>
            </div>
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto"
        >
            <div className="bg-white dark:bg-surface-900 rounded-2xl shadow-sm border border-surface-200 dark:border-surface-700 overflow-hidden min-h-[80vh]">
                <div className="p-4 border-b border-surface-200 dark:border-surface-700 flex items-center justify-between sticky top-0 bg-white/80 dark:bg-surface-900/80 backdrop-blur-md z-10">
                    <h1 className="text-xl font-bold font-poppins text-gray-900 dark:text-white flex items-center gap-2">
                        <Bell className="w-6 h-6 text-mavi-500" />
                        Bildirimler
                    </h1>
                </div>

                <NotificationList
                    events={events}
                    isLoading={isLoading}
                    loadMore={loadMore}
                />
            </div>
        </motion.div>
    );
};

export default NotificationsPage;
